import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {getPublicReleaseNotes} from "../common/api/WebApi";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Footer from "../Footer";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import Meta from "../common/Meta";
import PageLoading from "../common/PageLoading";
import {Chip} from "@mui/material";

export default function PublicReleaseNotes(props) {

  const [context, setContext] = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [release, setRelease] = useState(null);
  const [releases, setReleases] = useState([]);

  const getPublicReleaseNotesFn = async () => {
    let result = await getPublicReleaseNotes();
    if (result?.error) {
      // todo: handle error
    } else {
      setReleases(result);
      setLoading(false);
    }
  };

  useEffect(() => {
    getPublicReleaseNotesFn();
  }, []);

  const [releaseItem, setReleaseItem] = useState(null);

  const sortFn = (a, b)=> {
    const parse = v => v.name.replace(/^v/, '').split('.').map(Number);
    const [aParts, bParts] = [parse(a), parse(b)];

    for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
      const diff = (aParts[i] || 0) - (bParts[i] || 0);
      if (diff !== 0) return diff;
    }
    return 0;
  }



  return (
    <>
      <DashboardLayout>
        <Meta pageTitle={'Release Notes'}/>
        <ContextSearchNavbar title={'Release Notes'}/>
        <MDBox mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <MDBox pb={3}>
                <MDBox mb={3}>
                  <Card>
                    <MDBox p={3} lineHeight={1}>
                      {releases?.length > 0 && releases?.sort((a, b) => sortFn(b, a)).map((release, idx) => {
                        return (<div key={idx} style={{
                          border: 'solid 1px #ddd',
                          padding: '20px',
                          margin:'4px 0'
                        }}>
                          <h5>
                            {release.name} <Chip size='small' color={release.status.id === 1 ? 'primary' : 'secondary'} label={release.status.name} />
                          </h5>
                          <p>{release.description}</p>
                          <div  style={{
                            display:'block',
                            clear:'both'
                          }}>
                            {release?.releaseNotes?.length === 0 && <center>No Notes</center>}
                            <ul className={'list-group'}>
                              {release?.releaseNotes?.sort((a, b) => a.noteId - b.noteId)?.map((item, idx) => {
                                return (
                                  <li key={idx} className={'list-group-item'}>
                                    <p>{item.title}</p>
                                    <small style={{
                                      whiteSpace: 'pre-wrap'
                                    }}>{item.description}</small>

                                    {item?.releaseNoteUrl &&
                                      <p className={'my-2'}>
                                        <a href={item.releaseNoteUrl} target={"_blank"}>
                                          {item.releaseNoteUrl}
                                        </a>
                                      </p>
                                    }

                                  </li>
                                )
                              })}
                            </ul>

                          </div>

                        </div>)
                      })}

                    </MDBox>

                  </Card>
                </MDBox>

                {loading && <PageLoading/>}

              </MDBox>
            </Grid>
          </Grid>
        </MDBox>

        <Footer mt={5}/>

      </DashboardLayout>

    </>
  );
}